<template> 
   <div class="cn_title">
        

   </div>
</template> 
<script>
    export default {
        data () {
            return {
             
            }
        },
       
        computed: {
          
            
        },
        methods: {
               
           
            
        },
      
        mounted: function(){
            var that = this;
          
        }
    }
</script>  
<style scoped>
    
</style>
     